import React, { useEffect } from 'react';
import { css } from '@emotion/core';

function IgUseHtmlCodeToDisplay({ mediaData }) {
    useEffect(() => {
        if (typeof window.instgrm !== 'undefined') {
            window.instgrm.Embeds.process();
        }
    }, []);

    return (
        <div>
            {mediaData.map(({ origin }) => {
                return <div dangerouslySetInnerHTML={{ __html: origin }} css={divStyle}></div>;
            })}
        </div>
    );
}

export default IgUseHtmlCodeToDisplay;

const divStyle = css`
    > iframe {
        > .HoverCard {
            display: none;
        }
    }
`;
